import classNames from 'classnames';
import { IS_SERVER } from 'src/utils/checkRenderEnv';
import { KeyboardArrowRight } from '@mui/icons-material';
import { useHeaderLinksUtils } from '../../Widgets2.0/Header/utils';
import { smartWordBreakStyle } from 'src/utils/smartWordBreakStyle';
import { appendSlashToUrl } from 'src/utils/appendSlashToUrl';
import CommonLinkWrapper from '../../Widgets2.0/CommonLinkWrapper';

export const Option = ({
  option,
  idx,
  renderArray,
  isShopComponent,
  customItemConfigs,
  fromMobileMenuDrawer,
  handleMouseAction,
  isSubNavListActive,
}) => {
  const { handleHeaderNavItemClick, getHeaderNavInlineLink } = useHeaderLinksUtils();

  // Exact match the URL in the browser with the redirection link to prevent partial matching cases like : /blog, /blog/slug-url. Since these 2 are different links and should be treated as separate routes.
  const isNavLinkActive =
    !IS_SERVER && !!option.redirectionLink
      ? window.location.pathname === appendSlashToUrl(option?.redirectionLink)
      : false;

  const { onLinkHoverEnter, onLinkHoverLeave, getNavElementStyle } =
    customItemConfigs || {};
  const isLastOption = idx === renderArray.length - 1;
  const hasSubNavList = option?.type === 'dropdown';

  const OptionName = (
    <div className="tw-flex tw-w-full tw-items-center tw-justify-between">
      {option.name}
      {hasSubNavList && <KeyboardArrowRight fontSize="small" />}
    </div>
  );
  const inlineRedirectionLinkData = getHeaderNavInlineLink({
    ...option,
    isShopComponent,
  });

  return (
    <CommonLinkWrapper
      key={option.name}
      className={classNames(
        'tw-relative tw-px-[20px] [&>.underline-comp]:hover:tw-block',
        ((!option?.redirectionLink || isNavLinkActive) &&
          !isShopComponent &&
          !Object.hasOwn(option, 'id')) &&
          !hasSubNavList
          ? 'tw-pointer-events-none'
          : ' '
      )}
      onMouseOver={(e) => handleMouseAction?.(e.target)}
      link={inlineRedirectionLinkData.link}
      target={inlineRedirectionLinkData.target}
      disableLink={option.redirectNewPage || hasSubNavList}
      handleCustomClick={() => {
        if (option.redirectNewPage && !hasSubNavList)
          handleHeaderNavItemClick({ ...option, isShopComponent });
      }}
    >
      <p
        onMouseEnter={() => onLinkHoverEnter(idx)}
        onMouseLeave={onLinkHoverLeave}
        style={{
          ...(getNavElementStyle ? getNavElementStyle(idx) : {}),
          ...smartWordBreakStyle,
        }}
        className={
          'tw-relative tw-w-fit tw-max-w-[150px] tw-select-none tw-whitespace-normal tw-leading-normal hover:!tw-font-semibold [&_.underline-comp]:hover:tw-block ' +
          (!fromMobileMenuDrawer
            ? 'tw-m-0 tw-text-[12px] tw-tracking-[0.95px] ' +
              (!isLastOption ? 'tw-pb-[16px]' : '')
            : 'tw-m-0  ' + (!isLastOption ? 'tw-pb-[17.5px]' : '')) +
          (isSubNavListActive ? ' !tw-font-semibold' : '') +
          (hasSubNavList ? ' !tw-w-full' : '')
        }
        key={idx.id}
      >
        {OptionName}
      </p>
    </CommonLinkWrapper>
  );
};
